import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_minus",
  "use": "icon-icon_minus-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_minus\"><defs><style></style></defs><path d=\"M921.6 537.6H102.4a25.6 25.6 0 0 1 0-51.2h819.2a25.6 25.6 0 0 1 0 51.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol